import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, ShoppingBag } from 'lucide-react';
import { useCart } from '@/context/CartContext';
import Seo from '@/components/Seo';

export default function AppCart() {
  const navigate = useNavigate();
  const { openCart, items, itemCount } = useCart();

  // Redirect to cart drawer
  if (itemCount > 0) {
    openCart();
    navigate(-1);
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-background flex flex-col items-center justify-center px-5"
      data-testid="app-cart"
    >
      <Seo title="Your Cart" path="/cart" description="Review the items in your GC3H Online Canteen cart and check out securely." />
      <div className="text-center">
        <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <ShoppingBag className="h-12 w-12 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-semibold text-secondary-900 mb-2">Your Cart is Empty</h2>
        <p className="text-muted-foreground mb-8">Browse our menu and add items to your cart</p>
        <motion.button
          whileTap={{ scale: 0.95 }}
          onClick={() => navigate('/menu')}
          className="bg-primary text-white px-8 py-4 rounded-2xl font-semibold"
        >
          Browse Menu
        </motion.button>
      </div>
    </motion.div>
  );
}
